import { Link as RouterLink } from 'react-router-dom'
import { Button as MUIButton } from '@mui/material'
import PropTypes from 'prop-types'

const Button = (props) => {
  const { to, ...rest } = props
  return <MUIButton component={to ? RouterLink : undefined} to={to} {...rest} />
}

Button.propTypes = {
  to: PropTypes.string,
}

export default Button
